<template>
  <div>
    <div class="header">
      <img class="bg-img" src="https://iogw.cgo.ink:9000/hgzpub/pic/calendar/big@3x.webp" />
      <!-- <div class="title">
        <div @click="goBack()" class="img"><img src="@/assets/images/back-l.png" alt=""></div>
        <div>赛队介绍</div>
      </div> -->
    </div>
    <div class="box">
      <div class="card-title">参赛强队</div>
      <div class="card-box">
        <div class="content">
          <div class="label" @click="$router.push({ path: 'frc' })">
            <div class="name">FRC强队</div>
            <div class="icon"><img src="@/assets/images/rightArr.png" alt=""></div>
          </div>
          <div class="label" @click="$router.push({ path: 'roboMaster' })">
            <div class="name">RoboMaster劲旅</div>
            <div class="icon"><img src="@/assets/images/rightArr.png" alt=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
      created() {
        this.dataInfo = {
            title: '用户隐私协议',
            content: `敬请期待！`
        }
      },
      mounted() {},
      data() {
          return {
            dataInfo: {}
          }
      },
      methods: {
        goBack() {
          this.$router.go(-1)
        }
      },
      computed: {},
      watch: {},
      filters: {},
      components: {}
  }
  </script>

  <style lang="scss" scoped>
  .header{
    position: relative;
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #333333;
    background-color: #fff;
    .bg-img{
      width: 100%;
    }
    .title{
      position: absolute;
      top: 0;
      width: 100%;
      height: 44px;
      padding-top: 44px;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 800;
      font-size: 18px;
      color: #fff;
      line-height: 25px;
      text-align: left;
      font-style: normal;

      .img{
        img{
          height: 20px;
        }
        position: absolute;
        left: 16px;
        top: 34px;
      }
    }
  }
  .box{
    background: rgb(244, 247, 255);
    padding: 8px;
    min-height: calc(100vh - 214px);
    border-radius: 10px 10px 0 0;
    position: relative;
    top: -30px;
    z-index: 110;
  }
  .card-title{
      border-left: 5px solid red;
      padding-left: 10px;
      margin-left: 10px;
      margin-top: 18px;
    }
  .card-box{
    width: 100%;
    padding: 6px 10px;
    border-radius: 6px;
    .content{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        padding-top: 8px;
        .content-img{
          width: 100%;
        }
        .label{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 10px;
          box-shadow: 0px 2px 1px 0px rgba(222,229,243,0.3);
          background: #FFFFFF;
          border-radius: 2px;
          .name{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
          .icon{
            img {
              height: 14px;
            }
          }
        }
    }
}
</style>
